import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectWalletSlice } from '../redux/slices/walletSlice';

const useToChainWalletAddress = (): string | undefined => {
  const { connectedWallets, toChainWalletProvider } =
    useSelector(selectWalletSlice);

  return useMemo(
    () =>
      toChainWalletProvider
        ? connectedWallets[toChainWalletProvider.symbol]
        : undefined,
    [connectedWallets, toChainWalletProvider],
  );
};

export default useToChainWalletAddress;
